export default __webpack_public_path__ + "static/media/mlss.260d3026.png";